/** Vector beats for the unlinked-creator setup screen. */

export function ConnectArt() {
    return (
        <svg width="96" height="96" fill="none" viewBox="0 0 120 120" aria-hidden>
            <rect fill="#201f1f" height="66" rx="6" stroke="#ffc965" strokeWidth="1.5" width="36" x="42" y="24" />
            <rect fill="#131313" height="46" rx="3" width="28" x="46" y="32" />
            <rect fill="#767575" height="2" rx="1" width="12" x="54" y="28" />
            <circle cx="60" cy="55" opacity="0.4" r="38" stroke="#00fdc1" strokeDasharray="3 3" strokeWidth="1" />
            <g transform="translate(20, 44)">
                <circle cx="8" cy="8" fill="#262626" r="9" stroke="#00fdc1" strokeWidth="1" />
                <rect height="8" rx="2" stroke="#ffffff" strokeWidth="1" width="8" x="4" y="4" />
                <circle cx="8" cy="8" r="2" stroke="#ffffff" strokeWidth="0.8" />
            </g>
            <g transform="translate(84, 34)">
                <circle cx="8" cy="8" fill="#262626" r="9" stroke="#ffc965" strokeWidth="1" />
                <path
                    d="M8 12V7.5C8.8 8.3 9.7 8.5 10.8 8.5V7C9.8 7 9.2 6.5 9 5.5H7.8V12.2C7.8 13.1 7.1 13.8 6.2 13.8C5.3 13.8 4.5 13 4.5 12.2C4.5 11.3 5.3 10.5 6.2 10.5C6.5 10.5 6.8 10.6 7 10.7V9.4C6.7 9.3 6.5 9.2 6.2 9.2C4.5 9.2 3.2 10.5 3.2 12.2C3.2 13.8 4.5 15.1 6.2 15.1C7.9 15.1 9.2 13.8 9.2 12.2V12H8Z"
                    fill="#ffffff"
                />
            </g>
            <g transform="translate(52, 84)">
                <circle cx="8" cy="8" fill="#262626" r="9" stroke="#ffc965" strokeWidth="1" />
                <polygon fill="#ffffff" points="6,5 12,8 6,11" />
            </g>
        </svg>
    );
}

export function RateArt() {
    return (
        <svg width="96" height="96" fill="none" viewBox="0 0 120 120" aria-hidden>
            <rect fill="#201f1f" height="58" rx="8" stroke="#484847" strokeWidth="1.2" width="70" x="25" y="30" />
            <rect fill="#ffc965" height="6" rx="2" width="30" x="33" y="38" />
            <rect fill="#262626" height="14" rx="4" stroke="#767575" strokeWidth="0.8" width="54" x="33" y="50" />
            <text fill="#adaaaa" fontFamily="Manrope, sans-serif" fontSize="7" fontWeight="600" x="37" y="60">
                9:16 Video
            </text>
            <rect fill="#006c50" height="6" rx="2" width="12" x="71" y="54" />
            <circle cx="77" cy="57" fill="#00fdc1" r="1.5" />
            <rect fill="#131313" height="11" rx="3" width="34" x="33" y="69" />
            <circle cx="59" cy="74.5" fill="#ffc965" r="3.5" />
            <path d="M72 73L79 86L75 88L69 77L64 81V67L76 75L72 73Z" fill="#ffffff" stroke="#131313" strokeWidth="1" />
        </svg>
    );
}

export function CampaignArt() {
    return (
        <svg width="96" height="96" fill="none" viewBox="0 0 120 120" aria-hidden>
            <rect fill="#201f1f" height="46" rx="6" stroke="#484847" strokeWidth="1.2" width="68" x="26" y="42" />
            <path d="M28 44L60 67L92 44" stroke="#ffc965" strokeLinejoin="round" strokeWidth="1.5" />
            <rect fill="#262626" height="34" rx="4" stroke="#ffc965" strokeWidth="1" width="48" x="36" y="26" />
            <rect fill="#ffc965" height="4" rx="2" width="24" x="42" y="32" />
            <rect fill="#767575" height="3" rx="1.5" width="36" x="42" y="40" />
            <rect fill="#767575" height="3" rx="1.5" width="28" x="42" y="46" />
            <g transform="translate(74, 58)">
                <circle cx="12" cy="12" fill="#006c50" r="11" stroke="#00fdc1" strokeWidth="1.2" />
                <path
                    d="M8 12.5L10.5 15L16 9"
                    stroke="#00fdc1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
}

export function DeliverArt() {
    return (
        <svg width="96" height="96" fill="none" viewBox="0 0 120 120" aria-hidden>
            <rect fill="#131313" height="72" rx="7" stroke="#ffc965" strokeWidth="1.5" width="40" x="44" y="22" />
            <path d="M84 30V80" opacity="0.8" stroke="#feb700" strokeLinecap="round" strokeWidth="2" />
            <path d="M50 32H54V36" stroke="#ffffff" strokeLinecap="round" strokeWidth="1" />
            <path d="M78 32H74V36" stroke="#ffffff" strokeLinecap="round" strokeWidth="1" />
            <path d="M50 78H54V74" stroke="#ffffff" strokeLinecap="round" strokeWidth="1" />
            <path d="M78 78H74V74" stroke="#ffffff" strokeLinecap="round" strokeWidth="1" />
            <rect fill="#262626" height="20" rx="2" stroke="#00fdc1" strokeWidth="1" width="12" x="58" y="44" />
            <circle cx="64" cy="27" fill="#ff7351" r="2" />
            <g transform="translate(24, 62)">
                <circle cx="10" cy="10" fill="#201f1f" r="10" stroke="#484847" strokeWidth="1" />
                <path
                    d="M10 14V6M10 6L7 9M10 6L13 9"
                    stroke="#ffc965"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </svg>
    );
}

export function PaidArt() {
    return (
        <svg width="96" height="96" fill="none" viewBox="0 0 120 120" aria-hidden>
            <rect fill="#201f1f" height="48" rx="8" stroke="#ffc965" strokeWidth="1.5" width="60" x="30" y="38" />
            <rect fill="#131313" height="2" width="60" x="30" y="48" />
            <rect fill="#262626" height="18" rx="4" stroke="#feb700" strokeWidth="1" width="24" x="66" y="52" />
            <circle cx="74" cy="61" fill="#00fdc1" r="2.5" />
            <g transform="translate(36, 18)">
                <circle cx="9" cy="9" fill="#006c50" r="9" />
                <path
                    d="M9 13V5M9 5L6 8M9 5L12 8"
                    stroke="#00fdc1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
            <g transform="translate(68, 22)">
                <circle cx="10" cy="10" fill="#feb700" r="9" stroke="#533a00" strokeWidth="1" />
                <text
                    fill="#392700"
                    fontFamily="Plus Jakarta Sans, sans-serif"
                    fontSize="10"
                    fontWeight="800"
                    x="6.5"
                    y="14">
                    %
                </text>
            </g>
        </svg>
    );
}
